import {apiUtils} from "@/utils/apiUtils";
import {useShopStore} from "@/stores/shop";

export const shopService = {
    async selectShopById(shopId, emptyBasket) {
      try {
        const shopStore = useShopStore();

        const result = await apiUtils.doGet('/TCPSelectShopJ.action', {
          id: shopId,
          json: "true",
          emptyBasket: emptyBasket ? emptyBasket : false
        });

        const { id, custom1, custom2, name, image, custom6 } = result.shop;
        shopStore.setShop(id, custom1, custom2, name, image, custom6);

        return result;
      } catch (error) {
        console.error("Error on selecting a shop:", error);
        throw error;
      }
    },
    async selectShopByWondCode(wondCode, emptyBasket) {
      try {
        const shopStore = useShopStore();

        const result = await apiUtils.doGet('/TCPSelectShopJ.action', {
          wondCode: wondCode,
          json: "true",
          emptyBasket: emptyBasket ? emptyBasket : false
        });

        const { id, custom1, custom2, name, image, custom6 } = result.shop;
        shopStore.setShop(id, custom1, custom2, name, image, custom6);

        return result;
      } catch (error) {
        console.error("Error on selecting a shop:", error);
        throw error;
      }
    },
    async getShop(shopId) {
      try {
        const result = await apiUtils.doGet('/TCPShopsJ.action', {
          json: "true",
          shopId: shopId,
        });

        return result;
      } catch (error) {
        console.error("Error fetching shop:", error);
        throw error;
      }
    },
    async getShops(emptyBasket) {
        try {
            const result = await apiUtils.doGet('/TCPShopsJ.action', {
                json: "true",
                emptyBasket: emptyBasket,
            });

            return result;
        } catch (error) {
            console.error("Error fetching shops:", error);
            throw error;
        }
    }
};
